import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { SITE_URL } from '@/lib/seo';

export default function DisclaimerPage() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />

      <div className="pt-16 bg-background-50 border-b border-background-200">
        <div className="w-full px-4 md:px-8 lg:px-12 py-3">
          <nav aria-label="breadcrumb">
            <ol className="flex items-center gap-2 text-sm text-foreground-500">
              <li><a href="/" className="hover:text-primary-600 transition-colors">Home</a></li>
              <li><i className="ri-arrow-right-s-line text-xs" /></li>
              <li><span className="text-foreground-700">Disclaimer</span></li>
            </ol>
          </nav>
        </div>
      </div>

      <main className="flex-1 w-full px-4 md:px-8 lg:px-12 py-12 md:py-16 max-w-4xl mx-auto">
        <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-6">Disclaimer</h1>
        <div className="text-foreground-700 leading-relaxed space-y-4">
          <p>This website is an independent informational resource. All information is provided for educational purposes only. We are not affiliated with AllChinaBuy or any buying agent platform. Always conduct your own research before making purchases.</p>
          <h2 className="text-xl font-semibold text-foreground-900 mt-8 mb-2">No Financial or Legal Advice</h2>
          <p>
            The information provided on this website does not constitute financial, legal, or professional advice.
            We do not provide any warranty or guarantee regarding the accuracy, completeness, or timeliness of any information.
          </p>
          <h2 className="text-xl font-semibold text-foreground-900 mt-8 mb-2">Buying Risks</h2>
          <p>
            Buying products through international marketplaces and buying agents involves inherent risks including
            but not limited to: product quality issues, shipping delays, customs complications, seller disputes,
            and potential financial loss. You acknowledge and accept these risks when making any purchase decisions.
          </p>
          <h2 className="text-xl font-semibold text-foreground-900 mt-8 mb-2">Third-Party Content</h2>
          <p>
            This website may contain links to third-party websites and content. We are not responsible for any content,
            products, or services provided by third parties. Links to external sites do not constitute endorsement.
          </p>
          <h2 className="text-xl font-semibold text-foreground-900 mt-8 mb-2">Changes and Updates</h2>
          <p>
            We reserve the right to update, modify, or remove any content on this website at any time without notice.
            Information may become outdated, and we encourage visitors to verify current details directly with relevant platforms.
          </p>
          <p className="text-sm text-foreground-500 mt-8">
            Last updated: August 26, 2026
          </p>
        </div>
      </main>

      <Footer />

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "Disclaimer",
          "url": `${SITE_URL}/disclaimer/`,
          "description": "Disclaimer for AllChinaBuy Spreadsheet regarding the informational nature of our content and buying risks."
        })}
      </script>
    </div>
  );
}